export const PhoneInputButtonStyle = {
  background: 'none',
  border: 'none',
  height: '20px',
  paddingBottom: '4px',
};

export const PhoneInputTextAreaStyle = {
  background: 'none',
  border: 'none',
  width: '100%',
  height: '20px',
  paddingBottom: '4px',
};
